"use strict";

exports.__esModule = true;
exports.UtilizationChartThumbnail = UtilizationChartThumbnail;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Thumbnail for MetricChartWidget.
 */
function UtilizationChartThumbnail(props) {
  var _props$x = props.x,
    x = _props$x === void 0 ? 0 : _props$x,
    _props$y = props.y,
    y = _props$y === void 0 ? 0 : _props$y,
    width = props.width,
    height = props.height;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: width,
    height: height,
    x: x,
    y: y
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: x,
    y: y,
    width: width,
    height: height,
    fill: "#ffffff"
  }), generateBars(Object.assign({}, props, {
    x: x,
    y: y
  })));
}
function generateBars(_ref) {
  var x = _ref.x,
    y = _ref.y,
    width = _ref.width,
    height = _ref.height;
  var currentX = x + 2;
  var barWidth = 50;
  var totalPoints = Math.ceil((width - 4) / (barWidth + 2));
  var bars = [];
  for (var i = 0; i < totalPoints; i++) {
    var barHeight = (height - 4) * Math.random();
    bars.push(/*#__PURE__*/_react["default"].createElement("g", {
      key: String(i)
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      x: currentX,
      y: y + height - barHeight,
      width: barWidth,
      height: barHeight * 0.25,
      fill: "#FBBC6D"
    }), /*#__PURE__*/_react["default"].createElement("rect", {
      x: currentX,
      y: y + height - barHeight + barHeight * 0.25,
      width: barWidth,
      height: barHeight * 0.4,
      fill: "#6FC376"
    }), /*#__PURE__*/_react["default"].createElement("rect", {
      x: currentX,
      y: y + height - barHeight + barHeight * (0.25 + 0.4),
      width: barWidth,
      height: barHeight * 0.35,
      fill: "#F6928F"
    })));
    currentX += barWidth + 2;
  }
  return bars;
}